export default __webpack_public_path__ + "static/triebwerk_2-f0bddc3ba571d3756361d6ef359484a9.webp";